import { UsersTypes, UsersAction, User } from '../types';

export function getList(users: User[]): UsersAction<{ users: User[] }> {
    return {
        type: UsersTypes.GET_LIST,
        payload: { users },
    };
}

export function requestGetUsersList(roles: string[]): UsersAction<{ roles: string[] }> {
    return {
        type: UsersTypes.REQUEST_GET_LIST,
        payload: { roles },
    };
}

export function requestTryGetUsersByIds(
    uids: string[],
    roles: string[],
): UsersAction<{ uids: string[]; roles: string[] }> {
    return {
        type: UsersTypes.REQUEST_GET_USERS_BY_IDS,
        payload: { uids, roles },
    };
}

export function getUsersByIds(users: User[]): UsersAction<User[]> {
    return {
        type: UsersTypes.GET_USERS_BY_IDS,
        payload: users,
    };
}

export function addUser(user: User): UsersAction<User> {
    return {
        type: UsersTypes.ADD_USER,
        payload: user,
    };
}

export function requestAddUser(user: User): UsersAction<User> {
    return {
        type: UsersTypes.REQUEST_ADD_USER,
        payload: user,
    };
}

export function deleteUser(uid: string): UsersAction<{ uid: string }> {
    return {
        type: UsersTypes.DELETE_USER,
        payload: { uid },
    };
}

export function requestDeleteUser(uid: string): UsersAction<{ uid: string }> {
    return {
        type: UsersTypes.REQUEST_DELETE_USER,
        payload: { uid },
    };
}

export function editUser(uid: string, role: string): UsersAction<{ uid: string; role: string }> {
    return {
        type: UsersTypes.EDIT_USER,
        payload: { uid, role },
    };
}

export function requestEditUser(uid: string, newRole: string): UsersAction<{ uid: string; newRole: string }> {
    return {
        type: UsersTypes.REQUEST_EDIT_USER,
        payload: { uid, newRole },
    };
}
export function requestSendGlobalNotification(type: string): UsersAction<{ type: string }> {
    return {
        type: UsersTypes.REQUEST_SEND_GLOBAL_NOTIFICATION,
        payload: { type },
    };
}

export function requestSendUserNotification(
    type: string,
    uid: string,
    uidFrom: string,
): UsersAction<{ type: string; uid: string; uidFrom: string }> {
    return {
        type: UsersTypes.REQUEST_SEND_USER_NOTIFICATION,
        payload: { type, uid, uidFrom },
    };
}

export function userError(error: string) {
    return {
        type: UsersTypes.USER_ERROR,
        payload: { error },
    };
}

export function clearUserError() {
    return {
        type: UsersTypes.CLEAR_USER_ERROR,
    };
}
